<template>
    <div class="fileuploader">
        <label class="fileinputui1" v-if="!files.length">
            <input type="file" v-bind:accept="accept" v-bind:multiple="multiple" @change="upload">

            <h4 v-if="!loading"><i class="fa fa-cloud-upload fa-4x"></i><br>{{ select_label }}</h4>

            <h4 v-else><i class="fa fa-cloud-upload fa-4x"></i><br>{{ loading_label }}</h4>
        </label>

        <div class="filegridui1 m-bottom-20">
            <div v-for="file in files">
                <div>
                    <figure>
                        <img :src="file.url ? file.url : file.full_url">
                    </figure>

                    <div class="text-center">
                        <button type="button" class="btn btn-link btn-xs" @click="remove(file)" title="Remove file"><i class="fa fa-lg fa-remove"></i></button>
                    </div>
                </div>
            </div>
        </div>

        <div ref="hidden"></div>
    </div>
</template>

<script>
    export default {
        props: {
            multiple: {
                default: false
            },
            accept: {
                default: 'image/jpeg,image/gif,image/png',
            },
            select_label: {
                default: 'Selecteer bestand'
            },
            loading_label: {
                default: 'Uploaden...'
            },
            upload_url: {},
            remove_url: {},
            retrieve_url: {}
        },
        data() {
            return {
                files: [],
                loading: false
            }
        },
        created() {
            this.retrieve();
        },
        methods: {
            retrieve() {
                this.loading = true;
                this.$http.get(this.retrieve_url).then(function(response) {
                    this.files = response.data;
                    this.loading = false;
                });
            },
            remove(file) {
                this.loading = true;
                this.$http.get(this.remove_url + '/' + file.id).then(function(response) {
                    this.loading = false;
                    this.retrieve();
                });
            },
            upload(e) {
                var files, chunks, chunkBytes;

                files = e.target.files;
                if(files.length > 0) {
                    // Chunk object in porties van 20MB (20000000 bytes)
                    chunks = [[]];
                    chunkBytes = 0;

                    for(var key = 0; key < files.length; key++) {
                        if ((chunkBytes + files[key].size) > 20000000) {
                            chunks.push([]);
                            chunkBytes = 0;
                        }
                        chunks[chunks.length - 1].push(files[key]);
                        chunkBytes += files[key].size;
                    }

                    for(var key in chunks) {
                        var formData = new FormData();
                        for(var cKey in chunks[key]) {
                            formData.append('uploads[]', chunks[key][cKey]);
                        }

                        this.loading = true;
                        this.$http.post(this.upload_url, formData).then(function(response) {
                            this.loading = false;
                            this.retrieve();
                        }, function (response) {
                            alert('Fout bij uploaden van bestanden. Probeer het nogmaals.');
                        });
                    }
                }
            }
        }
    }
</script>

<style scoped>
  .fileinputui1 {
      background: #E7E7E7;
      padding: 1em;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/Uploader.vue